import { Injectable } from '@angular/core';
import { GenericService, LoaderConfig, ErrorConfig } from './generic.service';
import { UsersService } from './users.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ServerResponse } from '../models/ServerResponse';
import { CreateOpportunity } from '../models/Opportunity';
import { ISAPI, ISPagination } from 'is-lib';
import { IEnergySupplyProposals } from '../models/Proposals';
import { ICreateElectricitySupplyProposal, ICreateNaturalGasSupplyProposal, ICreateOpportunityEnergySupplyProposal } from '../models/EnergySupplyProposals';

@Injectable({
    providedIn: 'root'
})
export class OpportunitiesService {
    constructor(private genericService: GenericService, private _user: UsersService) {}


    //#region GET
    getOpportunity(opportunityId: string, loaderConfig: LoaderConfig | boolean = true, errorConfig?: ErrorConfig | boolean) {
        return this.genericService.get(`${environment.apiUrl}ClientPortalUsers/${this._user.userCountryCode}/Mine/Opportunities/${opportunityId}`, loaderConfig, undefined, undefined, errorConfig);
    }

    getOpportunities(body?: ISAPI, loaderConfig: LoaderConfig | boolean = true, errorConfig?: ErrorConfig | boolean) {
        if (body == null) {
            body = new ISAPI([], new ISPagination(100,0));
        }
        return this.genericService.post(`${environment.apiUrl}ClientPortalUsers/${this._user.userCountryCode}/Mine/Opportunities/Get`, body, undefined, loaderConfig, undefined, errorConfig);
    }

    getOpportunityElectricityMeters(opportunityId: string, body?: ISAPI, loaderConfig: LoaderConfig | boolean = true, errorConfig?: ErrorConfig | boolean): Observable<ServerResponse<any[]>> {
        if (body == null) {
            body = new ISAPI([], new ISPagination(100, 1))
        }
        return this.genericService.post(`${environment.apiUrl}Opportunities/${this._user.userCountryCode}/${opportunityId}/EnergyOpportunityElectricityMeters/Get`, body, undefined, loaderConfig, undefined, errorConfig);
    }

    getOpportunityNaturalGasMeters(opportunityId: string, body?: ISAPI, loaderConfig: LoaderConfig | boolean = true, errorConfig?: ErrorConfig | boolean): Observable<ServerResponse<any[]>> {
        if (body == null) {
            body = new ISAPI([], new ISPagination(100, 1))
        }
        return this.genericService.post(`${environment.apiUrl}Opportunities/${this._user.userCountryCode}/${opportunityId}/EnergyOpportunityNaturalGasMeters/Get`, body, undefined, loaderConfig, undefined, errorConfig);
    }
    //#endregion

    //#region POST
    createEnergyOpportunity(body: CreateOpportunity, loaderConfig: LoaderConfig | boolean = true, errorConfig?: ErrorConfig | boolean) {
        return this.genericService.post(`${environment.apiUrl}Opportunities/${this._user.userCountryCode}/`, body, undefined, loaderConfig, undefined, errorConfig);
    }

    associateElectricityMeterToEnergyOpportunity(body: any, opportunityId: string, loaderConfig: LoaderConfig | boolean = true, errorConfig?: ErrorConfig | boolean): Observable<ServerResponse<any>> {
        return this.genericService.post(`${environment.apiUrl}Opportunities/${this._user.userCountryCode}/${opportunityId}/EnergyOpportunityElectricityMeters`, body, undefined, loaderConfig, undefined, errorConfig);
    }

    associateNaturalGasMeterToEnergyOpportunity(body: any, opportunityId: string, loaderConfig: LoaderConfig | boolean = true, errorConfig?: ErrorConfig | boolean): Observable<ServerResponse<any>> {
        return this.genericService.post(`${environment.apiUrl}Opportunities/${this._user.userCountryCode}/${opportunityId}/EnergyOpportunityNaturalGasMeters`, body, undefined, loaderConfig, undefined, errorConfig);
    }
    //#endregion

    //#region Proposals
    createOpportunityEnergySupplyProposal(opportunityId: string, proposalData: ICreateOpportunityEnergySupplyProposal, loaderConfig: LoaderConfig | boolean = true, errorConfig?: ErrorConfig | boolean) {
        return this.genericService.post(`${environment.apiUrl}Opportunities/${this._user.userCountryCode}/${opportunityId}/EnergySupplyProposal`, proposalData, undefined, loaderConfig, undefined, errorConfig);
    }

    associateElectricityMeterToEnergySupplyProposal(body: ICreateElectricitySupplyProposal, energyProposalId: string, loaderConfig: LoaderConfig | boolean = true, errorConfig?: ErrorConfig | boolean): Observable<any> {
		return this.genericService.post(`${environment.apiUrl}OpportunityEnergySupplyProposals/${this._user.userCountryCode}/${energyProposalId}/ElectricitySupplyProposal`, body, undefined, loaderConfig, undefined, errorConfig)
	}

    associateNaturalGasMeterToEnergySupplyProposal(body: ICreateNaturalGasSupplyProposal, energyProposalId: string, loaderConfig: LoaderConfig | boolean = true, errorConfig?: ErrorConfig | boolean): Observable<any> {
		return this.genericService.post(`${environment.apiUrl}OpportunityEnergySupplyProposals/${this._user.userCountryCode}/${energyProposalId}/NaturalGasSupplyProposal`, body, undefined, loaderConfig, undefined, errorConfig)
	}
    //#endregion
}